const HelpfulLinks = {
  name: 'Helpful Links',
  links: [
    {
      title: 'Buyer’s Guides',
      href: '#'
    },
    {
      title: 'Calculators',
      href: '#'
    },
    {
      title: 'All Brands',
      href: '#'
    },
    {
      title: 'Catalog Updates',
      href: '#'
    }
  ]
};
export default HelpfulLinks;
